/* RP - Responsable de proceso -  toma decisión de la(s) propuesta(s) asignadas a su rol */
/* Contenido de pxf (detalles) */

//*react- recursos
    import { useState, useEffect } from "react";
    import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
    import CargandoSpin from "../../../../componentes/CargandoSpin";
    import { SlidingPanel } from "@reactjscomponentrepository/frontend-components/lib/components";

//*clases 
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css'; 

//*archivos (imagenes y elementos necesarios para la rutina)
    import VerRegistra from "./RP.Contenido.VerRegistrar";

//*api's (servicios y store)
    import proposalsServicio from "../../../../api/recursos/proposals/proposals.servicio"; 
    import proposalsStore from "../../../../api/recursos/proposals/proposals.store"; 

    import decisionsServicio from "../../../../api/recursos/decisions/decisions.servicio"; 
    import decisionsStore from "../../../../api/recursos/decisions/decisions.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    import articulos from "../../../../datos/json/guidelines.json";
    
//*funciones

//*interfaces
    interface propsRPContenido {
        tokenStore: any;
        pxfId: any,
        misPropuestas: any;
        misCiclos: any;
        catDecisionesStore: any;
        catPrincipiosStore: any;
        catPTEvidenciasStore: any;
        recargaCiclosStore:any;
        recargaRP: any;
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not:any;
    }

//*componente
 export default function RPContenido(props: propsRPContenido) {  
    //*api store
        const { guardaGetDetailbyUserStore, propuestaDetallesStore,
                generaObjErrorProposalsStore, objErrorProposalsStore} =  
            proposalsStore((state:any) =>( { 
                guardaGetDetailbyUserStore: state.guardaGetDetailbyUserStore,
                propuestaDetallesStore: state.propuestaDetallesStore,
                generaObjErrorProposalsStore: state.generaObjErrorProposalsStore,
                objErrorProposalsStore: state.objErrorProposalsStore
        }));

        const { guardaGetRateProposalStore, pxfPropuestasStore,
                generaObjErrorDecisionsStore } =  
            decisionsStore((state:any) =>( { 
                guardaGetRateProposalStore: state.guardaGetRateProposalStore,
                pxfPropuestasStore: state.pxfPropuestasStore, 
                generaObjErrorDecisionsStore: state.generaObjErrorDecisionsStore
        }));


    //*store's
     
    //*datos

    //*constantes y variables
        let etiRP = etiquetasSSC.RP;
        
    //*useState
        const [swRecarga, setSwRecarga] =  useState(false);
        const [swRecargaRPContenido, setSwRecargaRPContenido] =  useState(false); //usado para remasterizar esta página
        const [cargandoSpin,setCargandoSpin] = useState(false);

        const [swPxF, setSwPxF] = useState(false);
        const [abreSP, setAbreSP] = useState(false);
       
        const [propuestaDetallesFront, setPropuestaDetallesFront] = useState({}); // guarda la lectura de la propuesta desde proposal
        const [pxfPropuestaDetalleFront, setPxfPropuestaDetalleFront] = useState({});  //guarda la lectura de la propuesta desde desicions

        const dataMisPropuesta  = props.misPropuestas; 
        const [data, updateData] = useState(props.misPropuestas);
        const [status, setStatus] = useState(false);
      
    //*useEffect
        useEffect(()=> {   //usado para renderizar
            console.log('renderizando RP.Contenido........................');
            updateData(props.misPropuestas);
            setSwRecargaRPContenido(!swRecargaRPContenido);
        },[swRecarga]);

        useEffect(()=> {   //usado para renderizar
            console.log('renderizando RP.Contenido........................');
            setSwRecargaRPContenido(!swRecargaRPContenido);
        },[swRecarga]);

        useEffect(() => { 
            console.log('entro a useEffect cambio data')
            updateData(dataMisPropuesta);
            setSwRecarga(!swRecarga);
          }, [dataMisPropuesta]);

    //*funciones

        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana
        const recargaRP = () => { props.recargaRP() }

        const recargaRPContenido = () => {
            setSwRecarga(!swRecarga);
        }

        const recargaCiclos = () => {
            //alert('recargaCiclos desde RP contenido');
            props.recargaCiclosStore();  //funcion de RP para renderizar
        }

        const botonVerRegistrar = (idpxf:any, idProp:any, tipo:any) => {
            //alert('botonVerRegistrar...' + idpxf + '..' + idProp + '..'  + tipo);
            let pasoCatD= JSON.parse(JSON.stringify(props.catDecisionesStore));
            let pasoCatP= (tipo=='ver') ? null : JSON.parse(JSON.stringify(props.catPrincipiosStore));
            let pasoCatC= (tipo=='ver') ? null : JSON.parse(JSON.stringify(props.misCiclos));
            let pasoCatE= (tipo=='ver') ? null : JSON.parse(JSON.stringify(props.catPTEvidenciasStore));
            let body:any = {"id": 0, "proposal": { "id": 0 }};
            body.id = idpxf;
            body.proposal.id = idProp;
            //console.clear();
            //console.log('body...', body)
            setCargandoSpin(true);
            decisionsServicio.cargaGetRateProposal(props.tokenStore, body)
                .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetRateProposalStore(response.data, idpxf, idProp, tipo, pasoCatD, pasoCatP, pasoCatC, pasoCatE).then( function(pxfPropuestaDetalleF:any) { 
                        setPxfPropuestaDetalleFront(pxfPropuestaDetalleF);
                        leePropuestaPorId(idProp, 'boton-registra'); //con esta función cargamos el contenido de propuestaDetallesStore para presentar en la ventana splipanel
                        setSwPxF(!swPxF); //solo para renderizar
                        setAbreSP(true); // aquí activo ventana SlidingPanel (Ver/Registrar)
                        })
                    } 
                    setCargandoSpin(false);
                })
                .catch((ex) => {
                    console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
                    if (ex.response.status==404) //no es error solo no tiene información
                        console.log('nota: no es error solo no tiene información')
                    else
                        generaObjErrorDecisionsStore(ex.response, true, '', '', 'RPContenido-Decisions/GetRateProposal','RP')
                    setCargandoSpin(false);
                    recargaPaginaSSC();
                })
        }
      
        const leePropuestaPorId = (id:any, opcion:any) => { //opciones liga-verFichaCompleta , boton-registra lee el contenido de la propuesta 
            setCargandoSpin(true);
            proposalsServicio.cargaGetDetailbyUser(props.tokenStore, id)
              .then((response:any) => {
                if (response.status==200) {  //confirma que no hay error
                    guardaGetDetailbyUserStore(response.data, id, null, null, 'RPContenido').then( function(propuestaDetallesF:any) { 
                        //console.log('*propuestaDetallesFront: ' , propuestaDetallesFront)
                        setPropuestaDetallesFront(propuestaDetallesF);
                        let origenes=''
                        propuestaDetallesF.origin?.map((o:any, index:any) => (
                           origenes =  origenes 
                                       + "<p class='color-white'>" 
                                       + " <span class='padding-20px' >"
                                       +    "<i class='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;" 
                                       +     o.name + "</span><br/>"
                                       + " <span class='padding-40px'>" + o.specification + "</span>"
                                       + " <br />"         
                                       + "</p>" 
                        ))
                        let procFrec = propuestaDetallesF.processxfrequency[0];
                        let procStatus = procFrec.state_process;
                        let procesos=''
                        propuestaDetallesF.processxfrequency?.map((o:any, index:any) => (
                            procesos =  procesos 
                                        + "<p class='color-white'>" 
                                        + " <span class='padding-20px' >"
                                        +    "<i class='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;" 
                                        +     o.acronym + " / " +     o.processname  + "&nbsp;"
                                        +      "<span class='" + o.clasexEstatusIcono + "'>"
                                        +        o.state_process.pt_state_description
                                        +       "</span>"
                                        +     "</span><br/>"                                        
                                        +  " <br />"         
                                        + "</p>" 
                         ))
                        //console.log('------------procFrec2', procStatus.pt_state_description);
                        let clasexEstatusIcono='';
                        switch ( procStatus.pt_state ) {
                          case 1: clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                          case 2: clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                          case 3: clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                          case 4: clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                          default:clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                        }
                        if (opcion=='liga-verFichaCompleta') { // selecciono liga ver propuesta en tabla, abrimos ventana con la información de la propuesta
                            swal2.fire({
                                //icon: 'warning',
                                //showCancelButton: true,
                                confirmButtonText: "Cerrar",
                                confirmButtonColor: '#3085d6',
                                color: '#fff',
                                background: '#003057',
                                width: "70%",
                                title: 'Propuesta de cambio',
                                html: 
                                "<div>" 
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[4].text + "</span>" + propuestaDetallesF.folio + "</p>" 
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[5].text + "</span>" + propuestaDetallesF.fecha + "</p>" 
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[6].text + "</span> <br/>"
                                        + "<span class='padding-20px'> <i class='mdi mdi-account color-azul2 font-size-12'></i>&nbsp;" 
                                            + propuestaDetallesF.user.name  + "</span> <br/>" 
                                        + "<span class='padding-20px'> <i class='mdi mdi-email color-azul2 font-size-12'></i>&nbsp;" 
                                            + propuestaDetallesF.user.email + "</span> </p>" 
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[7].text + "</span> <br/>" 
                                        + "<span class='padding-20px'>" + propuestaDetallesF.description + "</span> </p>"                                     
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[8].text + "</span>" 
                                        + "<span class='padding-20px'>" + origenes + "</span> </p>" 
                                + "<p> <span class='color-azul2'>" + etiRP.etiquetas[9].text + "</span>" 
                                + "<span class='padding-20px'>" + procesos + "</span> </p>"                                         
                                + "</div>",
                            })
                        }
                    })
                } 
                setCargandoSpin(false);
              })
              .catch((ex) => {
                  //ex.response.data.result.errores.map((: any) => (
                  //toast.error(err.errorMessage)))
                  console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
                  if (ex.response.status==404) //no es error solo no tiene información
                      console.log('nota: no es error solo no tiene información')
                  else
                      generaObjErrorProposalsStore(ex.response, true, '', '', 'RPContenido-Decisions/GetDetailbyUser','RP')
                  setCargandoSpin(false);
                  recargaPaginaSSC();
              })
              setCargandoSpin(false);
        }

        const botonCierraSlidingPanel = (opcBtnAcepReg:any) => { setAbreSP(false) }

        // Ordenamiento de la tabla
            const onSort = (event: any, sortKey: any) => {
                const tempData = [...props.misPropuestas];
                setStatus(!status);
                if (status) {
                    updateData(
                    tempData.sort((a: any, b: any) => a[sortKey].localeCompare(b[sortKey]))
                    );
                } else {
                    updateData(
                    tempData.sort((a: any, b: any) => b[sortKey].localeCompare(a[sortKey]))
                    );
                }
            };

        //ordena por folio de mayor a menor (ascendente)
            props.misPropuestas.sort((a:any,b:any) => b.folio.localeCompare(a.folio));


    //*vista
     return (
         <>
          
           {/* contenido */}
            <div className='container'>
                <div className=" jumbotron">{/* margin-left-2r margin-right-2r */}
                  <div className="padding-1r">
                
                    <div className="table-responsive">
                        <table className="table table-bordered small background-color-white">
                          <thead id="theadTablaRP">
                            <tr className="background-color-azul7 font-weight-normal  align-top">
                                <th onClick={(e) => onSort(e, "sentOrden")} className="noBR  align-top" >
                                    <i className="h5 mdi mdi-swap-vertical color-white " title={etiRP.contenido[0].text}></i>
                                    {etiRP.contenido[0].text}
                                </th>
                                <th onClick={(e) => onSort(e, "description")} className="align-top " >
                                        <i className="h5 mdi mdi-swap-vertical color-white " title={etiRP.contenido[1].text} ></i>
                                        {etiRP.contenido[1].text}<br/>
                                        <span >
                                            <button  id="btnRT"  data-tip data-for="articulo818"> {etiRP.contenido[1].text2} </button>
                                                <ReactTooltip  id="articulo818" type="info"  place="right" multiline >
                                                    {articulos.hybridArticles[0].ch} <br/><br/>
                                                        Articulo: 8<br /> {articulos.hybridArticles[0].art[0].description}<br/><br />
                                                        Articulo: 18<br />{articulos.hybridArticles[0].art[1].description}<br/>
                                                </ReactTooltip>
                                        </span>             
                                </th>{/* thWidth30 */}
                                <th className="thOrigen">{etiRP.contenido[2].text}<br/>
                                    <span className="color-azul3">
                                            <button id="btnRT1" data-tip data-for="articulo818a"> {etiRP.contenido[1].text2} </button>
                                                <ReactTooltip  id="articulo818a" type="info"  place="right" multiline >
                                                    {articulos.hybridArticles[0].ch} <br/><br/>
                                                        Articulo: 8<br /> {articulos.hybridArticles[0].art[0].description}<br/><br />
                                                        Articulo: 18<br />{articulos.hybridArticles[0].art[1].description}<br/>
                                                </ReactTooltip>
                                    </span>  
                                </th>
                                <th onClick={(e) => onSort(e, "folio")} className="noBR  align-top" >
                                    <i className="h5 mdi mdi-swap-vertical color-white "  title={etiRP.contenido[3].text} ></i>
                                    {etiRP.contenido[3].text}
                                </th>
                                <th  onClick={(e) => onSort(e, "decisionOrden")} className="noBR  align-top" >
                                    <i className="h5 mdi mdi-swap-vertical color-white "  title={etiRP.contenido[4].text} ></i>
                                    {etiRP.contenido[4].text}
                                </th>
                                <th onClick={(e) => onSort(e, "cycleOrden")} className="noBR  align-top" >
                                    <i  className="h5 mdi mdi-swap-vertical color-white " title={etiRP.contenido[5].text} ></i>
                                    {etiRP.contenido[5].text}
                                </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* cambio props.misPropuestas por data para el manejo de la paginación*/}
                            {/* props.misPropuestas?.map((p:any, index:any) */}
                            { data?.map((p:any, index:any) => (

                                <tr  className="colorGris1 padding15Left ">

                                    {/* botones: Registrar / Ver  */}
                                    <td className="align-top background-color-azul">
                                        <div className="form-group">

                                            {/* botón 'Registrar' - No enviado */}
                                            {data[index].sentOrden == "2" 
                                            ? ( <>
                                                {/* "page.decbtnDec(decPro, depProItem, 'dec', indexPF);page.loadProposalbyID(depProItem.id,'dec',decPro.id)" */}
                                                <button id="btnDec_{pdxId}_{p.id}" onClick={() => botonVerRegistrar(props.pxfId, p.id, 'registrar')}  type="button" className="btn-registra">
                                                    <i className="mdi mdi-cursor-default-click"></i>&nbsp;{etiRP.botones[0].text}
                                                </button>                                            
                                              </>) 
                                            : (<>
                                                {/* ng-click="page.decbtnDec(decPro, depProItem, 'vis', indexPF);page.loadProposalbyID(depProItem.id,'dec',decPro.id) " */}
                                                <button id="btnDec_{pdxId}_{p.id}" onClick={() => botonVerRegistrar(props.pxfId, p.id, 'ver')}  type="button"  className="btn-ver" title={etiRP.contenido[8].text} >
                                                <i className="mdi mdi-eye-check-outline"></i>&nbsp;{etiRP.botones[1].text}
                                                </button>
                                              </>) 
                                            }
    {/*  <p>{p.miPropuestaDetalle.acronym}....</p> */}
                                        
                                        </div>  
                                    </td>

                                    {/* descripción */}
                                    <td data-title="data[index].description"   className="colDes-Origen">
                                        {data[index].description}
                                    </td>

                                    {/* origen */}
                                    <td className="maxwidth300 colDes-Origen">
                                        {data[index].origin.map((o: any, index: any) => (
                                            <>
                                                <span className="colorBlue1">
                                                <i className="mdi mdi-checkbox-marked colorBlue3 font-size-12"></i>&nbsp;{o.name}
                                                </span><br />
                                                {/* ng-bind-html="page.renderHtml(depProItemOrigin.specification.split('\n').join('<br />'))" */}
                                                <span className="padding-20px" >{o.specification}</span><br />
                                            </>    
                                        ))}
                                    </td>

                                    {/* ver ficha completa & folio   - (folio: {data[index].folio})*/}
                                    <td data-title="data[index].folio">
                                        <a className="text-link cursorHand noBR"  onClick={ () => leePropuestaPorId(p.id, 'liga-verFichaCompleta') } >
                                            {etiRP.contenido[7].text}<br />
                                            (folio: {data[index].folio})
                                        </a>
                                    </td>

                                    {/* decisión */}
                                    <td data-title="data[index].decisionOrden" className="background-color-azul">
                                        {data[index].decisionOrden != "" &&
                                            (<>
                                                {data[index].sentOrden
                                                    ? ( <i className="mdi mdi-checkbox-marked-circle colorBlue1 font-size-12"></i> )
                                                    : ( <i className="mdi mdi-checkbox-marked-circle colorBlue1 font-size-12"></i> )
                                                }  
                                                {data[index].decisionOrden}
                                            </>)
                                        }
                                    </td>
                            
                                    {/* ciclo */}
                                    <td className="background-color-azul"  data-title="data[index].cycleOrden">
                                        {data[index].cycleOrden != "" && <>{data[index].cycleOrden}</>}
                                    </td>

                                </tr>

                            ))}  
                          </tbody>
                        </table>
                    </div>

                    <SlidingPanel isOpen={abreSP} type='right' size={60}
                        title={etiRP.contenido[9].text} 
                        closeClick={()=>botonCierraSlidingPanel("")} >
                            <VerRegistra 
                                tokenStore = {props.tokenStore}
                                idPxF = {props.pxfId}
                                miPropuestaDetalle={pxfPropuestaDetalleFront} 
                                propuestaDetallesFront= {propuestaDetallesFront}
                                botonCierraSlidingPanel={botonCierraSlidingPanel}
                                recargaCiclos={recargaCiclos}
                                recargaRPContenido={recargaRPContenido}
                                recargaRP = {recargaRP}
                                recargaPaginaSSC = {recargaPaginaSSC}
                                recargaPaginaSSC_Not = {recargaPaginaSSC_Not }
                               // misArchivo = {pxfPropuestaDetalleFront.proposal}
                            /> 
                    </SlidingPanel>  

                  </div> 
                </div>

                {/* ventana de carga con spin que se abre mientras lee el api */}
                { cargandoSpin && <CargandoSpin />}

            </div>

         </>
          

     );
 }


  /* switch(responseAPI.status){
                    case 404:  paso.desresul= "El usuario no existe"; break;
                    case 401:  paso.desresul= "No autorizado"; break;
                    case 404:  paso.desresul= "No tiene información"; break;
                    default: paso.desresul= responseAPI.statusText; break;
                  } */

/* className={props.misPropuestas.sent ? 'divCatalogoDisabled' :'divCatalogo'} */